import config from 'config';
import Asset from 'containers/CreativePreview/components/CreativeBlock/Asset';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useQuery from 'reusable/customHooks/useQuery';
import { AssetContainerStyles } from './style';

function AssetsPreview() {
  const { fileName } = useParams<any>();
  const [query] = useQuery();
  const path = query.get('path');

  useEffect(() => {}, []);

  return (
    <AssetContainerStyles>
      <Asset
        url={`${config.serverUrl}/api/creative-testing/v1/asset/${fileName}?path=${path}`}
      />
    </AssetContainerStyles>
  );
}

export default AssetsPreview;
